/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import memoizeOne from 'memoize-one';

export const createGridRowData = memoizeOne(
  (
    rows,
    highlightedId,
    tableRowMode,
    totalColumnsWidth,
    allColumns,
    editRowData,
    prepareRow,
    onClickRow,
    onRowDoubleClick,
    handleEditRow,
    onEditRowChange,
    onHideEditRow,
    newRowData,
    subRowColumns,
    handleCreateSubRow,
    onNewRowChange,
    subRowId,
    handleEditSubRow,
    hiddenColumns,
    getRowStyle,
  ) => ({
    rows,
    highlightedId,
    tableRowMode,
    totalColumnsWidth,
    allColumns,
    editRowData,
    prepareRow,
    onClickRow,
    onRowDoubleClick,
    handleEditRow,
    onEditRowChange,
    onHideEditRow,
    newRowData,
    subRowColumns,
    handleCreateSubRow,
    onNewRowChange,
    subRowId,
    handleEditSubRow,
    hiddenColumns,
    getRowStyle,
  }),
);
